import {
  ArrowRightIcon,
  handleApiRequest,
  Loading,
  PersonalInfoFormContent,
  TPersonalInformationFormData,
  UserTypeEnum,
} from "@cpj-ai/panel-npm-package";
import {
  UpdateProfileMutation,
  UpdateProfileMutationVariables,
  useGetProfileQuery,
  useUpdateProfileMutation,
} from "@graphql/generated";
import { useProfile } from "@hooks/useProfile.ts";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { fromGraphQLProfile, toGraphQLProfile } from "./dto.ts";

interface IPersonalInfoTabContent {
  handleNextTab: () => void;
}

const PersonalInfoTabContent = ({ handleNextTab }: IPersonalInfoTabContent) => {
  const formHandler = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const { fetchProfile, profile } = useProfile();
  const { data: personalInformation, loading: getPersonalInfoLoading } = useGetProfileQuery();
  const [updateProfile, { loading: updateProfileLoading }] = useUpdateProfileMutation();

  const handleSubmit = async (formData: TPersonalInformationFormData) => {
    await handleApiRequest<UpdateProfileMutation, UpdateProfileMutationVariables>({
      apiFunction: updateProfile,
      variables: toGraphQLProfile(formData),
      componentName: "PersonalInformationForm",
      actionName: "updateProfile",
      successMessage: "Profile updated successfully",
      fallbackErrorMessage: "Failed to update profile. Please try again.",
      formHandler,
      extraErrorContext: {
        email: formData.email,
      },
      onSuccess: () => {
        handleNextTab();
        fetchProfile();
      },
    });
  };

  useEffect(() => {
    if (personalInformation) formHandler.reset(fromGraphQLProfile(personalInformation));
  }, [formHandler, personalInformation]);

  return (
    <div className="p-2 overflow-x-hidden">
      {getPersonalInfoLoading ? (
        <Loading />
      ) : (
        <PersonalInfoFormContent
          formHandler={formHandler}
          wrapInCard={false}
          userType={UserTypeEnum.USER}
          showCancel={false}
          fetchProfile={fetchProfile}
          profile={profile}
          submitProps={{
            onClick: formHandler.handleSubmit(handleSubmit),
            children: "Save & Next",
            isLoading: updateProfileLoading,
            isDisabled: updateProfileLoading,
            endContent: <ArrowRightIcon className="w-5 h-5 mt-1 stroke-white" />,
          }}
        />
      )}
    </div>
  );
};

export default PersonalInfoTabContent;
